import * as React from 'react';
import * as Redux from 'redux';
import { ISearchAppState } from '../../reducers/index';
import { fetchResults } from '../../actions/results';
import { IAutocompleteResults, IHit } from '../../state-helpers/autocomplete-results';
import { IEpiProps } from '../../state-helpers/epi-props';
import { setAutocompleteActive, setActiveHit } from '../../actions/index';
import { addUrlProps, UrlQueryParamTypes, subquery, multiPushInUrlQuery, pushInUrlQuery } from 'react-url-query';
import { ContextIds } from '../../../global/models/search-context';
import { AutocompleteResult } from './autocomplete-result';

interface IProps {
    searchTerm: string;
    autocompleteResults: IAutocompleteResults;

    onResultActive: (index: number) => void;
    onResultClick: (query: string, fromAutocomplete: boolean) => void;
    setSearchTerm: (searchTerm: string) => void;
}

/// <summary>
/// Creates and renders collection autocomplete items
/// </summary>
export class Autocomplete extends React.Component<IProps, any> {

    render() {
		return (
			<div className="search-autocomplete">
                <ul id="ulAutocomplete" className="unlisted">
                    {this.props.autocompleteResults.hits.map(this.renderAutocompleteHit)}
				</ul>
			</div>
		);
    }

    renderAutocompleteHit = (hit: IHit, index: number) => {
        const onResultActive = () => this.props.onResultActive(index);
        const onResultClick = () => {
            this.props.setSearchTerm(hit.query);
            this.props.onResultClick(hit.query, true);
        };

        return (
            <AutocompleteResult
                id={index}
                key={index}
                query={hit.query}
                searchTerm={this.props.searchTerm}
                isActive={this.props.autocompleteResults.activeHit === index}
                onResultActive={onResultActive}
                onResultClick={onResultClick} />
        );
    }
}